import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueClipboard from 'vue3-clipboard'
import event from './event'
import store from './store'

axios.defaults.withCredentials = true
axios.defaults.baseURL = store.state.webBaseUrl

const app = createApp(App)

app.provide('$event', event)
app.config.globalProperties.$event = event

app.use(VueAxios, axios)
  .use(VueClipboard, {
    autoSetContainer: true,
    appendToBody: true
  })
  .use(store)
  .use(router)
app.mount('#app')
